import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { careersApiService } from "@/src/lib/api-services/careersApiServices";
import JobDetail from "@/src/modules/careers/jobDetails";

export default function JobDetailsPage({ data }) {
    const jobData = data?.data;
    return (
        <div
            container
            className="bg-gray-100 min-h-screen" // Tailwind classes
            justifyContent="center"
            alignItems="flex-start"
        >
            <div className="p-5 max-w-6xl mx-auto">
                {jobData ? (
                    <JobDetail job={jobData} />
                ) : (
                    <div>No Job Data Found</div>
                )}
            </div>
        </div>
    );
}

JobDetailsPage.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export async function getServerSideProps(context) {
    const { jobId } = context.params || {};
    let initialData = null;

    try {
        if (jobId) {
            initialData = await careersApiService.jobDetails(jobId);
        }
    } catch (error) {
        console.error("Failed to fetch initial data:", error);
    }

    return {
        props: {
            data: {
                data: initialData || null,
                seoTitle: initialData?.data?.jobTitle,
                seoDescription: initialData?.data?.jobSummary,
                routerPath: `careers/${jobId}`,
            },
        },
    };
}
